import { toFullstoryProperty } from './string';
import { Survey, SurveyQuestion } from 'types/survey';

export const classNameList = (...classes: (string | boolean | null | undefined)[]): string => {
  return classes.filter((item) => !!item).join(' ');
};

export const getFullstoryProperties = (data: Survey | SurveyQuestion) => {
  let properties: Record<string, string | object> = {};

  const isSurvey = (data: any): data is Survey => {
    return data && typeof data === 'object' && 'surveyDefinitionId' in data;
  };
  const isSurveyQuestion = (data: any): data is SurveyQuestion => {
    return data && typeof data === 'object' && 'questionId' in data;
  };

  switch (true) {
    case isSurvey(data):
      properties = {
        'data-survey-id': `${toFullstoryProperty(data.surveyDefinitionId)}`,
        'data-survey-name': `${toFullstoryProperty(data.name)}`,
        'data-survey-sector': `${toFullstoryProperty(data.sector)}`,
        'data-fs-properties-schema': JSON.stringify(
          {
            'data-survey-id': 'str',
            'data-survey-name': {
              type: 'str',
              name: 'surveyName'
            },
            'data-survey-sector': {
              type: 'str',
              name: 'surveySector'
            }
          },
          null,
          '\t'
        )
      };

      break;
    case isSurveyQuestion(data):
      properties = {
        'data-question-id': `${toFullstoryProperty(data.questionId)}`,
        'data-question-name': `${toFullstoryProperty(data.name)}`,
        'data-question-type': `${toFullstoryProperty(data.type)}`,
        'data-fs-properties-schema': JSON.stringify(
          {
            'data-question-id': 'str',
            'data-question-name': {
              type: 'str',
              name: 'questionName'
            },
            'data-question-type': {
              type: 'str',
              name: 'questionType'
            }
          },
          null,
          '\t'
        )
      };

      break;
  }

  return properties;
};
